export default __webpack_public_path__ + "static/media/medical-records-large-2.9fdf1da4.png";